import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './UpgradePage.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';




const UpgradePage = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [stripeError, setError] = useState(true);

  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [subscriptionEndsAt, setSubscriptionEndsAt] = useState(null);
  const [currentTier, setCurrentTier] = useState(null);

  useEffect(() => {
    fetchUserProfile();
  }, []);

  const fetchUserProfile = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/login');
        return;
      }

      const response = await fetch(`${API_URL}/user/profile`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setUser(data);
        setCurrentTier(data.tier);
        setSubscriptionStatus(data.subscriptionStatus);
        setSubscriptionEndsAt(data.subscriptionEndsAt);
      } else {
        navigate('/login');
      }
    } catch (err) {
      console.error('Error fetching profile:', err);
      navigate('/login');
    } finally {
      setLoading(false);
    }
  };

  const tiers = [
    {
      id: 'free',
      name: 'Free',
      icon: '🆓',
      price: 0,
      features: [
        '1 Persona',
        '4 Events per persona',
        '5 Daily predictions',
        'Basic analytics'
        
      ],
      limitations: [
        'Limited personas',
        'Basic features only'
      ]
    },
    {
      id: 'paid',
      name: 'Paid',
      icon: '💎',
      price: 2.99,
      features: [
        '3 Personas',
        '6 Sequences per persona',
        '15 Daily predictions',
        'Advanced analytics',
        'Ad Free experience',
        'Advanced comprehensive report'
      ],
      popular: true,
      badge: 'Most Popular'
    },
    {
      id: 'premium',
      name: 'Premium',
      icon: '👑',
      price: 6.99,
      features: [
        '5 Personas',
        '8 Sequences per persona',
        '25 Daily predictions',
        'Ad Free experience',
        'Early access to new features',
        'Personalized parameters',
        'Advanced Analysis report',
        'Community Ambassador',
        'Event Contribution'
        
      ],
      badge: 'Best Value'
    }
  ];

  const handleCancelSubscription = async () => {
    if (!window.confirm('Are you sure you want to cancel your subscription? You will keep access until the end of your billing period, then be downgraded to the Free plan.')) {
      return;
    }

    setLoading(true);
    setError('');
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`${API_URL}/stripe/cancel-subscription`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();

      if (response.ok) {
        alert(data.message);
        // Refresh user profile to show updated status
        fetchUserProfile();
      } else {
        console.log(data.error || 'Failed to cancel subscription');
      }
    } catch (err) {
      console.log('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCancelSubscriptionObs = async () => {
    if (!window.confirm('Are you sure you want to cancel your subscription? You will be downgraded to the Free plan.')) {
      return;
    }
    const token = localStorage.getItem('token');
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_URL}/stripe/cancel-subscription`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();

      if (response.ok) {
        alert(data.message);
        // Refresh user data
        fetchUserProfile();
      } else {
        console.log(data.error || 'Failed to cancel subscription');
      }
    } catch (err) {
      console.log('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleUpgrade = (tier) => {
    if (tier.id === 'free') {
      // User trying to downgrade - handle separately
      alert('To downgrade to free plan, please contact support or cancel your subscription.');
      return;
    }

    // Navigate to payment page with tier data
    navigate('/payment', {
      state: { tier }
    });
  };

  if (loading) {
    return (
      <div className="upgrade-page">
        <div className="loading-container">
          <div className="spinner-large"></div>
          <p>Loading plans...</p>
        </div>
      </div>
    );
  }

  /*const currentTier = user?.tier || 'free';*/

  return (
    <div className="upgrade-page">
      <div className="upgrade-container">
        {/* Header */}
        <div className="upgrade-header">
          <h1>Choose Your Plan</h1>
          <p>Select the perfect plan for your prediction needs</p>
        </div>

        {/* Current Plan Badge */}
        <div className="current-plan-indicator">
          <span className="indicator-label">Current Plan:</span>
          <span className={`tier-badge-current tier-${currentTier}`}>
            {currentTier === 'free' && '🆓 Free'}
            {currentTier === 'paid' && '💎 Paid'}
            {currentTier === 'premium' && '👑 Premium'}
          </span>
          <br/>

          {/* Show subscription status and duration*/}
            {subscriptionStatus && (
              <div className="subscription-status-obs">
                <p className={`status-badge ${subscriptionStatus}`}>
                  {subscriptionStatus === 'active' && ' Active'}
                  {subscriptionStatus === 'cancelling' && ' Cancelling'}
                  {subscriptionStatus === 'past_due' && ' Payment Failed'}
                  {subscriptionStatus === 'cancelled' && ' Cancelled'}
                </p>

                {subscriptionStatus === 'cancelling' && subscriptionEndsAt && (
                  <p className="subscription-info">
                    Access until: {new Date(subscriptionEndsAt).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </p>
                )}
              </div>
            )}
        </div>

            


        {/* Pricing Toggle (if you want monthly/yearly) */}
        {/* <div className="billing-toggle">
          <button className="toggle-btn active">Monthly</button>
          <button className="toggle-btn">Yearly <span className="discount">Save 20%</span></button>
        </div> */}

        {/* Tiers Grid */}
        <div className="pricing-tiers">
          {tiers.map((tier) => (
            <div
              key={tier.id}
              className={`pricing-card ${tier.popular ? 'popular' : ''} ${
                currentTier === tier.id ? 'current-plan' : ''
              }`}
            >
              {/* Popular/Best Value Badge */}
              {tier.badge && (
                <div className="tier-badge-top">
                  {tier.popular && '⭐'} {tier.badge}
                </div>
              )}

              {/* Current Plan Indicator */}
              {currentTier === tier.id && (
                <div className="current-plan-badge">
                  ✓ Your Current Plan
                </div>
              )}

              {/* Tier Header */}
              <div className="pricing-header">
                <span className="pricing-icon">{tier.icon}</span>
                <h2 className="pricing-name">{tier.name}</h2>
              </div>

              {/* Price */}
              <div className="pricing-price">
                {tier.price === 0 ? (
                  <div className="price-free">
                    <span className="price-amount">Free</span>
                  </div>
                ) : (
                  <>
                    <span className="price-currency">$</span>
                    <span className="price-amount">{tier.price}</span>
                    <span className="price-period">/month</span>
                  </>
                )}
              </div>

              {/* Features */}
              <ul className="pricing-features">
                {tier.features.map((feature, index) => (
                  <li key={index} className="feature-item">
                    <span className="feature-check">✓</span>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              {/* Limitations (for free tier) */}
              {tier.limitations && (
                <ul className="pricing-limitations">
                  {tier.limitations.map((limitation, index) => (
                    <li key={index} className="limitation-item">
                      <span className="limitation-icon">−</span>
                      <span>{limitation}</span>
                    </li>
                  ))}
                </ul>
              )}

              {/* CTA Button */}
              <div className="pricing-cta">
                {currentTier === tier.id ? (
                  <button className="cta-button current" disabled>
                    Current Plan
                  </button>
                ) : tier.price === 0 ? (

                  <button 
                    className="cta-button downgrade"
                    onClick={handleCancelSubscription}
                    disabled={loading}
                  >
                    Cancel Subscription
                  </button>

                ) : currentTier === 'premium' && tier.id === 'paid' ? (
                  <button 
                    className="cta-button downgrade"
                    onClick={() => handleUpgrade(tier)}
                  >
                    Downgrade to {tier.name}
                  </button>
                ) : (
                  <button 
                    className="cta-button upgrade"
                    onClick={() => handleUpgrade(tier)}
                  >
                    {currentTier === 'free' ? 'Upgrade' : 'Switch'} to {tier.name}
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Comparison Table */}
        <div className="comparison-section">
          <h2>Compare Plans</h2>
          <div className="comparison-table-wrapper">
            <table className="comparison-table">
              <thead>
                <tr>
                  <th>Feature</th>
                  <th>Free</th>
                  <th>Paid</th>
                  <th>Premium</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Personas</td>
                  <td>1</td>
                  <td>3</td>
                  <td>5</td>
                </tr>
                <tr>
                  <td>Sequences per Persona</td>
                  <td>4</td>
                  <td>6</td>
                  <td>8</td>
                </tr>
                <tr>
                  <td>Daily Predictions</td>
                  <td>5</td>
                  <td>15</td>
                  <td>25</td>
                </tr>
                <tr>
                  <td>ads</td>
                  <td>yes</td>
                  <td>no</td>
                  <td>no</td>
                </tr>
                <tr>
                  <td>Analytics</td>
                  <td>Standard</td>
                  <td>Advanced</td>
                  <td>Advanced Plus</td>
                </tr>
                <tr>
                  <td>Early Access to new features</td>
                  <td>−</td>
                  <td>✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td>Personalized Parameters</td>
                  <td>−</td>
                  <td>-</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td>Community Ambassador</td>
                  <td>−</td>
                  <td>−</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td>Event Contribution</td>
                  <td>−</td>
                  <td>−</td>
                  <td>✓</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="faq-section">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h3>Can I change plans anytime?</h3>
              <p>Yes! You can upgrade or downgrade your plan at any time. Changes take effect at the next billing cycle.</p>
            </div>
            <div className="faq-item">
              <h3>What payment methods do you accept?</h3>
              <p>We accept all major credit cards, Apple Pay, and Google Pay through our secure Stripe integration.</p>
            </div>
            <div className="faq-item">
              <h3>Is there a refund policy?</h3>
              <p>Yes! We offer a 30-day money-back guarantee. If you're not satisfied, contact us for a full refund.</p>
            </div>
            <div className="faq-item">
              <h3>Can I cancel my subscription?</h3>
              <p>Absolutely. You can cancel anytime from your account settings. Your plan will remain active until the end of the billing period.</p>
            </div>
          </div>
        </div>

        {/* Trust Section */}
        <div className="trust-section">
          <div className="trust-item">
            <span className="trust-icon">🔒</span>
            <h3>Secure Payment</h3>
            <p>256-bit SSL encryption</p>
          </div>
          <div className="trust-item">
            <span className="trust-icon">↩️</span>
            <h3>30-Day Guarantee</h3>
            <p>Full money-back</p>
          </div>
          <div className="trust-item">
            <span className="trust-icon">💳</span>
            <h3>No Hidden Fees</h3>
            <p>Cancel anytime</p>
          </div>
          <div className="trust-item">
            <span className="trust-icon">⚡</span>
            <h3>Instant Activation</h3>
            <p>Immediate access</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradePage;